import { ProductVariant } from '@commerce/types/product'
import { useEffect } from 'react'

export function EmbedSocialReviews() {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://embedsocial.com/embedscript/ri.js'
    script.id = 'EmbedSocialReviewsScript'
    script.async = true
    document.getElementsByTagName('head')[0].appendChild(script)

    return () => {
      const script = document.getElementById('EmbedSocialReviewsScript')
      if (script) {
        script.remove()
      }
    }
  }, [])
  return null
}
export function TaggShopEmbed() {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://app.taggshop.io/js/embed.min.js'
    script.id = 'TaggShopEmbedScript'
    script.defer = true
    script.type = 'text/javascript'
    document.getElementsByTagName('head')[0].appendChild(script)

    return () => {
      const scriptElement = document.getElementById('TaggShopEmbedScript')
      if (scriptElement) {
        scriptElement.remove()
      }
    }
  }, [])

  return null
}

export const hasVideo = (productVariant: ProductVariant) => {
  if (
    productVariant.videos &&
    productVariant.videos.length > 0 &&
    (productVariant.videos[0].local_url ||
      productVariant.videos[0].alternative_url)
  ) {
    return true
  } else {
    return false
  }
}
